import { isProdMode, isMobile } from '@src/utils';

export const initVConsole = () => {
    if (isProdMode() || !isMobile()) return;

    import('vconsole').then(({ default: VConsole }) => {
        new VConsole();
    });
};
